import React from 'react';
import { Typography } from '../../../design-system';
import { colors } from '../../../design-system/colors';
import { LEARNING_SUBTITLE } from '../constants/landingText';

interface LearningSubtitleProps {
  fontSize?: { xs: string; md: string };
  maxWidth?: string;
}

const LearningSubtitle: React.FC<LearningSubtitleProps> = ({
  fontSize = { xs: '18px', md: '20px' },
  maxWidth = '39rem',
}) => {
  return (
    <Typography
      variant="subheading"
      component="p"
      sx={{
        fontSize,
        fontWeight: 400,
        lineHeight: { xs: '1.5', md: '1.4' },
        color: colors.neutral.white,
        maxWidth,
        margin: '0 auto',
        mb: 0,
        textAlign: 'center',
        fontFamily: 'Outfit, sans-serif',
      }}
    >
      {LEARNING_SUBTITLE}
    </Typography>
  );
};

export default LearningSubtitle;
